<template>
  <div class="">
    <navbar></navbar>
    <main class="main bg-light" role="main">

      <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
          <!-- <li data-target="#carouselExampleIndicators" data-slide-to="2"></li> -->
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item active carousel-img" style="background-image:url(../../../static/img/carousel1.png);">
          </div>
          <div @click="carousel2Jump" class="carousel-item carousel-img" style="background-image:url(../../../static/img/carousel2.png);cursor:pointer;">
          </div>
          <!-- <div class="carousel-item carousel-img" style="background-image:url(../../../static/img/1.jpg);">
          </div> -->
        </div>
        <a class="carousel-control-prev pt-5" style="border-bottom-width:0px;border-bottom-style:none" href="#carouselExampleIndicators" role="button" data-slide="prev">
          <span class="flickity-prev-next-button previous bg-white row justify-content-center align-items-center" style="height:60px;width:60px"><svg viewBox="0 0 100 100" style="height:44px;width:44px">
              <path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path>
            </svg></span>
          <span class="sr-only">{{$t('top.Previous')}}</span>
        </a>
        <a class="carousel-control-next pt-5" style="border-bottom-width:0px;border-bottom-style:none" href="#carouselExampleIndicators" role="button" data-slide="next">
          <span class="flickity-prev-next-button next bg-white row justify-content-center align-items-center" style="height:60px;width:60px" aria-hidden="true"><svg viewBox="0 0 100 100" style="height:44px;width:44px">
              <path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path>
            </svg></span>
          <span class="sr-only">{{$t('top.Next')}}</span>
        </a>
      </div>

      <div class="bg-light py-5">
        <div class="container">
          <div class="text-center mb-5">
            <h3>{{$t('top.mytheme')}}</h3>
          </div>
          <div class="row justify-content-center">
            <div class="col-md-9">
              <div class="row">
                <div class="col-6 col-lg-6">
                  <router-link class="card mb-4" to="order">
                    <div class="card-body my-3 text-center">
                      <i class="far fa-3x fa-chart-bar mb-2 text-warning"></i>
                      <h5 class="mb-0 font-weight-light">{{$t('top.myorder')}}</h5>
                    </div>
                  </router-link>
                </div>
                <div class="col-6 col-lg-6">
                  <router-link class="card mb-4" to="info">
                    <div class="card-body my-3 text-center">
                      <i class="far fa-3x fa-user-circle mb-2 text-primary"></i>
                      <h5 class="mb-0 font-weight-light">{{$t('top.mysettings')}}</h5>
                    </div>
                  </router-link>
                </div>
              </div><!-- /.row -->
            </div>
          </div><!-- /.row -->
          <div class="row justify-content-center">

          </div>
          <div class="row justify-content-center">

          </div><!-- /.row -->
        </div>
      </div>

    </main>
    <copyright></copyright>
  </div>
</template>

<style src="../../../static/css/dashboard.css" />

<script type="text/javascript">
import navbar from './navbar'
import copyright from './copyright'
export default {
  components: { navbar, copyright },
  data: function () {
    return {
    }
  },
  mounted() {
    $('#carouselExampleIndicators').carousel(
      {interval: 3000}
    )
  },
  methods: {
    carousel2Jump() {
      window.open('https://individual.payglobal.me/auth/register/Vmv8jwH5', '_blank')
    }
  }
}
</script>
<style scoped>

#carouselExampleIndicators{
 background-color: transparent !important;
}
.carousel-control-prev{

}
.carousel-img{
    width:100%;
    height:0;
    padding-bottom: 300px;
    overflow:hidden;
    background-position: center center;
    background-repeat: no-repeat;
    -webkit-background-size:cover;
    -moz-background-size:cover;
    background-size:cover;

}

.main{
  min-height:calc(100vh - 160px)
}
</style>



// WEBPACK FOOTER //
// src/components/user/top.vue